import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    flex: '1 1 auto',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'calc(100% - 4rem)',
    padding: '0'
  },

  disabled: {
    '& *': {
      color: 'grey',
      cursor: 'default !important'
    }
  },

  controls: {
    display: 'flex',
    marginBottom: '8px',
    fontSize: theme.size.sm
  },

  textfield: {
    width: '80%',
    marginBottom: '10px'
  },

  control: {
    padding: '0 1rem',

    '& .MuiRadio-colorPrimary.Mui-checked': {
      color: '#2595D0'
    },

    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: theme.size.lg
    }
  },

  label: {
    display: 'flex',

    '& .text': {
      opacity: '0.7',
      fontSize: theme.size.sm,
      display: 'flex',
      alignItems: 'center'
    }
  },

  Live: {
    color: '#88388F'
  },

  Email: {
    color: '#697B64'
  },

  SMS: {
    color: '#C87A3C'
  },

  Phone: {
    color: '#C87A3C'
  },

  type: {
    display: 'flex',
    alignItems: 'center',
    color: 'grey',
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer')
  },

  channelIcon: {
    margin: '0',
    marginRight: '0.5rem',
    border: 'none',
    width: '0.9375rem',
    height: '0.9375rem',
    color: 'grey'
  },

  fields: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto'
  },

  textArea: {
    border: 'none',
    width: ({ SMS }) => (SMS ? '85%' : '100%'),
    padding: '0.25rem 0',
    backgroundColor: 'transparent',
    outline: 'none',
    wordBreak: 'normal',
    overflowWrap: 'anywhere',

    '& .text': {
      minHeight: ({ smallMedia, keepHeight }) =>
        smallMedia ? '0' : keepHeight ? '7rem' : '2rem',
      maxHeight: ({ keepHeight }) => (keepHeight ? '24rem' : '12rem')
    },

    '& .text > div': {
      height: 'auto !important',
      maxHeight: ({ smallMedia, keepHeight }) =>
        smallMedia ? '4rem' : keepHeight ? '24rem' : '12rem',
      minHeight: ({ smallMedia, keepHeight }) =>
        smallMedia ? '0' : keepHeight ? '7rem' : '2rem'
    },

    '& .text > div > div': {
      height: 'auto !important',
      maxHeight: ({ keepHeight }) => (keepHeight ? '24rem' : '12rem')
    }
  },

  count: {
    position: 'absolute',
    top: '20px',
    right: '34px',
    opacity: '0.7',
    fontSize: theme.size.base,
    color: '#323436',
    marginBottom: '-4px'
  },

  banner: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto 0.25rem auto',
    borderRadius: '10px',
    width: 'calc(100% - 64px)'
  },

  controlContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    padding: ({ SMS }) => (SMS ? '13px 18px 0 18px' : '6px 18px 0 18px')
  },

  disableArea: {
    position: 'relative',
    border: '0.125rem solid #F1F1F1',
    borderRadius: '0.5rem',
    boxSizing: ({ banner }) => (banner ? 'content-box' : 'border-box'),
    opacity: ({ doneUploading }) => (doneUploading ? '1' : '0.5'),
    pointerEvents: ({ doneUploading }) => (doneUploading ? 'visible' : 'none'),
    backgroundColor: 'white'
  },

  sendControls: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem auto',
    width: '100%'
  },

  recordingControls: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.5rem',
    width: '100%'
  },

  controlsBlock: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0.5rem',
    boxSizing: 'border-box',
    padding: '0 0 0 8px'
  },

  icon: {
    cursor: ({ fileLength }) => (fileLength ? 'default' : 'pointer')
  },

  children: {
    flex: '1',
    paddingRight: '1rem'
  },

  recordingStatus: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 12,
    animation: '$fading 2s infinite',
    marginRight: 6
  },

  '@keyframes fading': {
    '0%': {
      opacity: 1
    },
    '50%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  },

  recordingDot: {
    backgroundColor: 'red',
    borderRadius: '50%',
    height: 10,
    width: 9,
    marginRight: 5
  }
}))

export default useStyles
